import { z } from 'zod';

export const zodCreateForwardedInvoicePreviewSchema = z.object({
  companyId: z.uuid(),
  processId: z.uuid(),
  reasonCode: z.int().nonnegative(),
});
